import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classes from './checksCard.module.scss';
import cn from 'classnames';
import { useOutletContext } from 'react-router-dom';
import CardContentByMode from './modeTileContent';
import { safeJsonParse } from '../../../../../../utility/helperFunction';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const CardContent = ({ check, setSelectedCheck, isSelected, currentMode }) => {
  const MODE_BUTTONS = {
    DEFAULT: [
      { label: FLABEL().CHECK_NOTIFY, action: 'notifyGuest', type: 'handler' },
      { label: 'Dynamic', type: 'statusUpdate' },
    ],
    ON_PREMISE: [
      { label: FLABEL().CHECK_PRINT, action: 'print', type: 'handler' },
      { label: FLABEL().CHECK_RECEIPT, action: 'receipt', type: 'handler' },
    ],
    OFF_PREMISE: [
      { label: FLABEL().CHECK_NOTIFY, action: 'notifyGuest', type: 'handler' },
      { label: 'Dynamic', type: 'statusUpdate' },
    ],
    TABLE_DELIVERY: [
      { label: FLABEL().CHECK_NOTIFY, action: 'notifyGuest', type: 'handler' },
      { label: 'Dynamic', type: 'statusUpdate' },
    ],
    OFF_PREMISE_VENUE: [
      { label: FLABEL().CHECK_NOTIFY, action: 'notifyGuest', type: 'handler' },
      { label: 'Dynamic', type: 'statusUpdate' },
    ],
  };
  const { handleExpandedRightSection, updateOrderStatus } = useOutletContext();
  const deviceGroup = safeJsonParse(
    window.sessionStorage.getItem('deviceInfo'),
    {}
  )?.deviceGroup;
  const handlers = { handleExpandedRightSection, updateOrderStatus };
  const footerButtons = MODE_BUTTONS[currentMode] || MODE_BUTTONS.DEFAULT;
  const [buttonState, setButtonState] = useState('complete');
  const isStatus = currentMode !== 'ON_PREMISE';
  const isChannel =
    currentMode !== 'ON_PREMISE' && currentMode !== 'TABLE_DELIVERY';
  const isVenueMode = deviceGroup?.startMode === 6 || false;

  useEffect(() => {
    const status = check?.status?.status?.toLowerCase();
    if (status === 'complete') {
      setButtonState('pickedUp');
    } else if (status === 'picked up') {
      setButtonState('disabled');
    } else if (status === 'pending') {
      setButtonState('inProgress');
    }
  }, [check?.status?.status]);

  const getButtonLabel = label => {
    if (label !== 'Dynamic') return label;
    if (buttonState === 'inProgress') return FLABEL().CHECK_PROGRESS;
    if (buttonState === 'complete') return FLABEL().CHECK_COMPLETE;
    if (buttonState === 'pickedUp' || buttonState === 'disabled')
      return FLABEL().CHECK_PICKEDUP;
    return FLABEL().CHECK_COMPLETE;
  };

  const handleClick = btn => {
    if (btn.type === 'handler') {
      handlers.handleExpandedRightSection(btn.action);
    } else if (btn.type === 'statusUpdate') {
      if (buttonState === 'complete') {
        updateOrderStatus(check, 'complete');
        setButtonState('pickedUp');
      } else if (buttonState === 'pickedUp') {
        updateOrderStatus(check, 'pickedUp');
        setButtonState('disabled');
      } else if (buttonState === 'inProgress') {
        updateOrderStatus(check, 'inProgress');
        setButtonState('complete');
      }
    }
  };

  return (
    <div
      className={cn(
        classes.cardContainer,
        'col-12 p-0',
        isSelected && classes.selecteditem
      )}
      onClick={() => setSelectedCheck(check?.id)}
    >
      <div
        className={cn(
          classes.TileHeader,
          currentMode === 'ON_PREMISE'
            ? 'justify-content-center'
            : 'justify-content-between',
          'd-flex align-items-center'
        )}
      >
        {isChannel && <div className={classes.channelIcon}>{check?.mode}</div>}
        <div
          className={cn(
            'd-flex px-1 text-truncate',
            currentMode === 'ON_PREMISE' ? 'col-12' : 'col-5',
            currentMode === 'TABLE_DELIVERY'
              ? 'text-left'
              : 'text-center justify-content-center'
          )}
        >
          {currentMode === 'TABLE_DELIVERY' ? (
            <>
              <span>#</span>
              <div className={cn(classes.checkTruncate, 'px-0 text-center')}>
                {check.number}
              </div>
            </>
          ) : (
            <div className={cn('text-truncate col px-0')}>
              {check?.tabName || check?.orderDetails?.orderName || '---'}
            </div>
          )}
        </div>
        {isStatus && (
          <div
            className={cn('rounded-pill fw-400 text-right', classes.statusPill)}
            style={{
              backgroundColor: check?.status?.color,
              border: check?.status?.border,
            }}
          >
            {check.status?.status}
          </div>
        )}
      </div>

      <CardContentByMode
        check={check}
        mode={currentMode}
        isVenue={isVenueMode}
      />

      <div className="col-12 px-1 d-flex gap-2 pb-2 mt-auto">
        {footerButtons.map(btn => {
          const isDisabled =
            buttonState === 'disabled' && btn.type === 'statusUpdate';
          return (
            <div className="col-6 px-1">
              <button
                className={cn(
                  classes.primaryBtn,
                  'col-12 px-1 fw-500',
                  isDisabled && classes.disabledbtn
                )}
                disabled={isDisabled}
                onClick={() => handleClick(btn)}
              >
                {getButtonLabel(btn.label)}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

CardContent.propTypes = {
  check: PropTypes.object.isRequired,
  setSelectedCheck: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  currentMode: PropTypes.string.isRequired,
};

export default CardContent;
